import React, { PureComponent, Fragment } from 'react'
import styled, { css } from 'styled-components'
import { connect } from 'react-redux'
import { withRouter, Link } from 'react-router-dom'
import { Icon, BlurLayer } from 'gipsy-ui'
import { styles, translations } from 'gipsy-misc'
import { MobileSupportChat } from 'features/supportchat'
import { elementHasNotifications } from 'features/notifications/utils'

const mapStateToProps = state => ({
  notifications: state.notifications.list
})

class MobileNavbar extends PureComponent {
  state = {
    active: false,
    showSupportChat: false
  }

  isTodolist = () => {
    const { location } = this.props
    return (
      location.pathname === '/' ||
      location.pathname === '/archive' ||
      location.pathname === '/index.html' ||
      location.pathname.indexOf('/calendar') !== -1 ||
      location.pathname === '/focusview'
    )
  }

  isTeam = () => {
    const { location } = this.props
    return location.pathname === '/team' || location.pathname === '/team/archive'
  }

  isSettings = () => {
    const { location } = this.props
    return location.pathname === '/settings'
  }

  toggleMenu = () => {
    this.setState({
      active: !this.state.active
    })
  }

  closeMenu = () => {
    this.setState({ active: false })
  }

  render() {
    const { active, showSupportChat } = this.state
    const { notifications } = this.props

    return (
      <Fragment>
        <div className="mobile-navbar-container">
          <div className="mobile-navbar">
            <Link to="/" className="button" onClick={this.closeMenu}>
              <BackgroundIcon
                className="todolist"
                isActive={this.isTodolist()}
                icon="Checked"
                fill="white"
                size={19}
                style={{ marginRight: 0 }}
                dot={elementHasNotifications(notifications, 'todolist')}
              />
            </Link>
            <a className="button" onClick={this.toggleMenu}>
              {!active && (
                <Icon
                  icon="BurgerMenu"
                  fill={active ? styles.colors.primaryColor : styles.colors.darkGrey}
                  size={16}
                  dot={
                    elementHasNotifications(notifications, 'todolist') ||
                    elementHasNotifications(notifications, 'teamlist')
                  }
                />
              )}
              {active && (
                <Icon icon="Close" size={16} fill={active ? styles.colors.primaryColor : styles.colors.darkGrey} />
              )}
            </a>
          </div>
          <BlurLayer name="mobile-menu" active={active} onClose={this.closeMenu}>
            <Fragment>
              <MenuLink to="/" onClick={this.closeMenu}>
                <BackgroundIcon
                  className="todolist"
                  isActive={this.isTodolist()}
                  size={19}
                  fill="white"
                  icon="Checked"
                  dot={elementHasNotifications(notifications, 'todolist')}
                />
                <MenuLabel isActive={this.isTodolist()}>{translations.navbar.todolist}</MenuLabel>
              </MenuLink>
              <MenuLink to="/team" onClick={this.closeMenu}>
                <MenuIcon
                  icon="Team"
                  size={19}
                  fill={this.isTeam() ? styles.colors.primaryColor : styles.colors.darkGrey}
                  dotSpace={10}
                  dot={elementHasNotifications(notifications, 'teamlist')}
                />
                <MenuLabel isActive={this.isTeam()}>{translations.navbar.teamlist}</MenuLabel>
              </MenuLink>
              <FakeLink disabled={true}>
                <MenuIcon icon="Chart" size={19} />
                <MenuLabel>{translations.navbar.reports}</MenuLabel>
              </FakeLink>
              <FakeLink onClick={() => this.setState({ showSupportChat: true })}>
                <BackgroundIcon size={20} icon="QuestionMark" fill="white" isActive={showSupportChat} />
                <MenuLabel isActive={showSupportChat}>Help</MenuLabel>
              </FakeLink>
              <MenuLink to="/settings" onClick={this.closeMenu}>
                <MenuIcon
                  icon="Settings"
                  size={19}
                  fill={this.isSettings() ? styles.colors.primaryColor : styles.colors.darkGrey}
                />
                <MenuLabel isActive={this.isSettings()}>{translations.navbar.settings}</MenuLabel>
              </MenuLink>
            </Fragment>
          </BlurLayer>
        </div>
        {this.state.showSupportChat && <MobileSupportChat onClose={() => this.setState({ showSupportChat: false })} />}
      </Fragment>
    )
  }
}

export default withRouter(
  connect(
    mapStateToProps,
    null,
    null,
    {
      pure: true
    }
  )(MobileNavbar)
)

const linkStyle = css`
  display: flex;
  flex-direction: row;
  align-items: center;
  height: 48px;
  margin-bottom: 8px;
  text-decoration: none;
  color: inherit;
  font-weight: 500;
  opacity: ${props => (props.disabled ? '0.7' : '1')};
`

const MenuLink = styled(Link)`
  ${linkStyle}
`

const MenuLabel = styled.div`
  color: ${props => (props.isActive ? styles.colors.primaryColor : 'inherit')};
`

const FakeLink = styled.a`
  ${linkStyle}
`

const BackgroundIcon = styled(Icon)`
  transition: background-color 0.2s ease;
  background-color: ${props => (props.isActive ? styles.colors.primaryColor : styles.colors.darkGrey)};
  padding: 5px;
  border-radius: 10px;
  margin-right: 16px;
  &:hover {
    background-color: ${styles.colors.primaryColor};
  }
`

const MenuIcon = styled(Icon)`
  margin-right: 16px;
`



// WEBPACK FOOTER //
// ./src/features/layout/components/navbarMobile/index.js